import React, { useContext, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faUser, faShieldExclamation, faEye, faSpinner } from "@fortawesome/pro-solid-svg-icons"; // Added faSpinner
import { faKeySkeleton, faCircle } from "@fortawesome/pro-regular-svg-icons";
import { Divider } from "primereact/divider";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context";
import JSEncrypt from "jsencrypt";
import { MainApi, Platform } from "../../../../services/authentication/api";
import { Configuration } from "../../../../services/authentication/configuration";
import { login, setRememberMe, setFavoritesSecuritiesData } from "../../../../stores/auth";
import { Toast } from "primereact/toast";
import { setMainDefaultSecurity, setSelectedSecurity } from "../../../../stores/security";
import { set } from "lodash";
import { WatchListAllSymbolsServiceApi } from "../../../../services/actionHub/api";
import { el } from "date-fns/locale";
import { APIControl } from "../../../../helpers/APIControl";
import { Checkbox } from 'primereact/checkbox';
import { ProfileServiceApi } from "../../../../services/profile/api";
import { Configuration as ProfileConfiguration } from "../../../../services/profile/configuration";
import { setWatchlist } from "../../../../stores/watchlist";
import { setProfileBasicDetail } from "../../../../stores/profileSlice";
import { useTranslation } from "react-i18next";

const MetKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3prLK5rWvXhOfC8JyMImg
NWH1XaY8+pQGs5FVy0dAPcogNi7FJKQvjNOx2nNl4ESU1ShT3TNe69L8x45MR2zg
OGbgN1NXdCCYu7bsJlQUxWuu1jEqZVl5PKgz8JSrkk47kRUFHw2Ogb50nYhR9X0q
LaU+UZshu5UG/ut/gaSS8TStrHwGifYsVRJIytSldEWlUWtuh19dc7RHVhwd3nd5
lBqqJC3cy2va2rRjC0f/UwHCANfvOPMT1Kfe+9ygihQ8l9B199+kgzy1Z/loBRsr
mVttnyKF9qvjzXbk5ZaFznyAFOu0pdLf3Wqp0X7YPFV7K2tqBoLJACUpH2NSUDej
AgMBAAE=
-----END PUBLIC KEY-----`;

export default function MemberLoginForm() {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(MetKey);

  const mainApi = new MainApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH));
  const profileService = new ProfileServiceApi(new Configuration({ basePath: process.env.REACT_APP_PROFILE_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_PROFILE_API_BASE_PATH));

  const watchListAllSymbolsServiceApi = new WatchListAllSymbolsServiceApi(new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useRef(null);
  const contextVal = useContext(AuthContext);
  const rememberMe = useSelector((state) => state.auth?.rememberMe);
  const userObj = useSelector((state) => state.auth);
  const [memberLoginInputs, setMemberLoginInputs] = useState({ email: userObj?.email, password: userObj?.password });
  const [rememberMeCheck, setRememberMeCheck] = useState(rememberMe);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (rememberMe) {
      setMemberLoginInputs({ email: userObj?.email, password: userObj?.password });
      setRememberMeCheck(rememberMe);
    }
  }, [rememberMe, userObj?.email, userObj?.password]);

  const handleForgotPassword = () => {
    try {
      contextVal.setAuthState({
        ...contextVal?.authState,
        loginView: false,
        verificationView: false,
        passwordResetView: true,
      });
    } catch (error) {
      console.error("Error handling forgot password:", error);
    }
  };

  const memberLoginHandler = (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading state to true when login starts
    try {
      const { email, password } = memberLoginInputs;

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      const emailControl = emailRegex.test(email);

      if (!emailControl) {
        toast.current.show({
          severity: "error",
          summary: "Sorun",
          detail: "Geçerli bir mail adresi girmelisiniz.",
          life: 3000,
        });
        setIsLoading(false); // Reset loading state on validation error
      } else {
        const uname = encrypt.encrypt(email);
        const pass = encrypt.encrypt(password);

        let params = {
          loginRequest: { Username: uname, Password: pass },
        };

        mainApi.apiMainSigninWithUsernamePasswordPost(Platform.Web, params.loginRequest)
          .then((res) => {
            setIsLoading(false); // Reset loading state on API response

            if (res.data.Status !== "Error") {
              if (rememberMeCheck) dispatch(setRememberMe(rememberMeCheck));

              let userCred = {
                mail: email,
                password: password,
                user: res.data.Data,
                token: res.data.Data.TokenId,
                accountId: res.data.Data.AccountId,
                expireDate: res.data.Data.ExpireDate,
              };

              getUserWatchlistData(res.data.Data.TokenId);
              getProfileBasicDetail(res.data.Data.TokenId);
              dispatch(setSelectedSecurity({
                "alternativeName": "",
                "code": "TUPRS",
                "Code": "TUPRS",
                "countryCode": "TR",
                "dataId": 368,
                "elite": false,
                "id": "sec.101.368",
                "index": false,
                "listed": true,
                "name": "TÜPRAŞ",
                "objectId": "sec.101.368",
                "screenable": true,
                "sourceId": 101,
                "uniqueCode": "TUPRS:IS",
                "visible": true
              }));

              dispatch(login(userCred));

              getDefaultSecurity(res.data.Data.TokenId)
              // navigate("/StockAnalysis/summary/TUPRS");

            } else {
              const errorCodes = ["0x7D3D2F", "0xBC3E1F", "0xNT3A2B"];

              if (res.data.Error.includes("0xB45138")) {
                toast.current.show({
                  severity: "error",
                  summary: "Bir hata oluştu.",
                  detail: "Kullanıcı adı veya şifre hatalı.",
                  closable: true,
                  life: 3000,
                });
              }
              else if (errorCodes.some(code => res.data.Error.includes(code))) {
                toast.current.show({
                  severity: "error",
                  summary: "Bir hata oluştu.",
                  detail: "Hesap bilgilerinizi kontrol ediniz. " + res.data.Error,
                  closable: true,
                  life: 3000,
                });
                return;
              }
              else {
                toast.current.show({
                  severity: "error",
                  summary: "Bir hata oluştu.",
                  detail: res.data.Error,
                  closable: true,
                  life: 3000,
                });
              }

            }
          })
          .catch((error) => {
            setIsLoading(false); // Reset loading state on API error
            toast.current.show({
              severity: "error",
              summary: "Hata",
              detail: "Sunucu bağlantısında bir sorun oluştu.",
              closable: true,
              life: 3000,
            });
            console.error("API error:", error);
          });
      }
    } catch (error) {
      setIsLoading(false); // Reset loading state on any other errors
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: error.toString(),
        closable: true,
        life: 3000,
      });
    }
  };


  const getDefaultSecurity = (token) => {

    try {
      profileService.profileFetchstockGet(token).then((response) => {
        console.log('getDefaultSecurity', response);

        if (response.data.error.length > 0) {
          console.log('getDefaultSecurity', response.data.error);
          toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data.error, life: 3000 });
          return;
        }

        dispatch(setMainDefaultSecurity(response.data.securityCode));

        navigate("/StockAnalysis/summary/" + response.data.securityCode);

      }
      ).catch((error) => {
        console.log('getDefaultSecurity', error);
      });

    } catch (error) {
      console.log('getDefaultSecurity', error);
    }
  }


  const registerRedirect = () => {
    navigate("/auth/register");
  };

  const handleMouseDownPassword = () => {
    setIsShowPassword(true);
  };

  const handleMouseUpPassword = () => {
    setIsShowPassword(false);
  };

  const getUserWatchlistData = (token) => {
    try {
      const culture = "tr-TR";
      watchListAllSymbolsServiceApi.actionhubWatchlistallsymbolsGet(token, culture).then((response) => {
        if (!response.data.error) {
          console.log("getUserWatchlistData:", response.data.watchlist);
          let data = response.data.watchlist;
  
          data = data.filter(element => !element.id.includes('xu030') && !element.id.includes('xu100'));
  
          const favoritesSecuritiesData = data.flatMap(element =>
            element.securitiesEntityIds.map(security => ({
              ...security,
              watchlistId: element.id,
              watchlistName: element.name,
            }))
          );
  
          dispatch(setWatchlist(favoritesSecuritiesData));
        } else {
          console.error("getUserWatchlistData:", response.data.error);
        }
      });
    } catch (error) {
      console.error("getUserWatchlistData error:", error);
    }
  };
  
  

  const getProfileBasicDetail = async (token) => {
    try {
      await profileService.profileBasicprofiledetailGet(token).then((response) => {
        console.log('getProfileBasicDetail', response);
        if (response.data.error != "") {
          console.log('getProfileBasicDetail', response.data.error);
          toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data.error, life: 3000 });
          return;
        }

        dispatch(setProfileBasicDetail(response.data.profile));
        i18n.changeLanguage(response.data.profile.languagecode);
      }).catch((error) => {
        console.log('getProfileBasicDetail', error);
      });
    } catch (error) {
      console.log('getProfile', error);
    }
  };

  return (
    <>
      <Toast ref={toast} position="bottom-right" />
      <div>
        <Row className="uyeGirisInfo m-0 m-t-40">
          <label className="p-0">
            Demo süresi 1 ay içinde kullanılmak üzere toplam <strong>30 Dakikadır.</strong>
          </label>
        </Row>
        <Form onSubmit={memberLoginHandler}>
          <Row className="m-t-40">
            <Form.Group className="mb-3" controlId="ControlInput1">
              <InputGroup className="user-mail-input-group w-100">
                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                  <FontAwesomeIcon icon={faUser} className="userLoginUserIcon" />
                </InputGroup.Text>
                <Form.Control type="text" className="customRegisterInput" placeholder="E Posta Adresi" value={memberLoginInputs.email} onChange={(e) => { setMemberLoginInputs({ ...memberLoginInputs, email: e.target.value }) }} />
              </InputGroup>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3" controlId="ControlInput7">
              <InputGroup className="user-password-input-group w-100">
                <InputGroup.Text id="inputGroup-sizing-default" className="p-5">
                  <FontAwesomeIcon icon={faKeySkeleton} className="userLoginKeyIcon" />
                </InputGroup.Text>
                <Form.Control className="userLoginPassword customRegisterInput"
                  value={memberLoginInputs.password}
                  onChange={(e) => { setMemberLoginInputs({ ...memberLoginInputs, password: e.target.value }) }}
                  type={isShowPassword ? "text" : "password"}
                  aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Şifre" name="password1" />
                <InputGroup.Text id="inputGroup-sizing-default" className="userLoginEyeIcon"
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  onMouseLeave={handleMouseUpPassword}
                >
                  <FontAwesomeIcon icon={isShowPassword ? faEye : faEyeSlash} />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="remember-forgotpass-row">
            <Col xs="6" className="p-t-0">
              <Checkbox
                inputId="rememberMe"
                checked={rememberMeCheck}
                onChange={(e) => setRememberMeCheck(e.checked)}
                className="rememberMeCheckbox"
              />
              <label htmlFor="rememberMe" className="rememberMeCheck">Beni Hatırla</label>
            </Col>
            <Col xs="6" className="userForgotPassword p-t-0" onClick={handleForgotPassword}>
              <a>Şifrenizi mi unuttunuz ?</a>
            </Col>
          </Row>
          <Row style={{ display: "inline" }} className="m-0 ">
            <Button 
              slot="end" 
              type="submit" 
              variant="dark" 
              className="loginBtn m-t-40 m-b-15"
              onClick={memberLoginHandler}
              disabled={isLoading} // Disable button when loading
            >
              {isLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : "GİRİŞ YAP"}
            </Button>
          </Row>
          <Row style={{ display: "inline" }} className="m-0">
            <Button slot="end" variant="dark" className="registerBtn" onClick={registerRedirect}>
              DEMO HESABI AÇ
            </Button>
          </Row>
        </Form>
        <Divider align="center" className="loginDivider">
          <FontAwesomeIcon icon={faCircle} className="loginDividerIcon" />
        </Divider>
        <Row className="m-0 loginFooterInfo">
          <label className="loginFooterInfoLabel">Osmanlı Yatırım müşterisi olarak ilk giriş öncesinde e-şube hesabım / veri dağıtım talep ekranından HisseLAB ürün talebini oluşturmanız gerekmektedir.</label>
          <label className="shieldExclamationDiv">
            <FontAwesomeIcon icon={faShieldExclamation} className="shieldExclamationIcon" />
          </label>
        </Row>
      </div>
    </>
  );
}
